import { useGetAppReleaseHistoryQuery as useGetAppReleaseHistoryAppQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc-app.hooks';
import { useGetAppReleaseHistoryQuery as useGetAppReleaseHistoryPublicQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.hooks';
export function useAppReleaseHistory({
  appContext,
  slug,
  skip
}) {
  const isPublic = appContext === 'public';
  const {
    data: publicData
  } = useGetAppReleaseHistoryPublicQuery({
    variables: {
      slug
    },
    skip: !isPublic || skip
  });
  const {
    data: appData
  } = useGetAppReleaseHistoryAppQuery({
    variables: {
      slug
    },
    skip: isPublic || skip
  });
  return appData || publicData;
}